import React, { ReactElement } from 'react';
import Button from '../button/button.component';
import TextBlock from '../text-block/text-block.component';
import useStylesControlModeButton from './control-mode-button.styles';

const ControlModeButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    title,
    onClick,
    iconComponent,
  } = props;

  const { classes } = useStylesControlModeButton();

  return (
    <Button
      isText
      isDefault
      className={classes.controlModeButton}
      onClick={onClick}
    >
      {iconComponent}
      <TextBlock className={classes.controlModeButtonLabel}>
        {title}
      </TextBlock>
    </Button>
  );
});

export default ControlModeButton;
